  <span [ngClass]="{'hand': !params?.isCursorNotallowed}"
  class="" (click)="!params?.isCursorNotallowed && !params?.isTooltipEnabled?changeRoute(params):null"  [ngbTooltip]="params?.isTooltipEnabled ? params?.tooltipData : null"
  placement="bottom"
  container="body">{{ (params?.dataToShow ?? params?.value) || '&#8212;'  }}</span>
  <ng-container *ngIf="params?.buttonVisible">
    <button  placement="bottom" ngbTooltip="{{params?.buttondata}}" class="btn ms-3 d-none hold-btn">On Hold</button>
  </ng-container>
